import React, { Fragment } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Breadcrumb from '../common/breadcrumb';
import { DOCS } from './docsData';
import { scrollPageToTop } from './scrollPageToTop';

import '../../assets/scss/app-styles/users.scss';
import './docs.scss';

class DocsSummary extends React.Component {
    componentDidMount() {
        scrollPageToTop();
    }

    openDoc = (docId) => {
        scrollPageToTop();
        this.props.history.push(`${process.env.PUBLIC_URL}/docs/${docId}`);
    };

    render() {
        return (
            <Fragment>
                <Breadcrumb parent="App" title="Docs" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <Card>
                                <CardHeader>
                                    <h5>Documentation</h5>
                                    <span>
                                        Architecture and service reference for the VTSL platform.
                                        Click a document to open the full detail page.
                                    </span>
                                </CardHeader>
                                <CardBody>
                                    <div className="docs-summary-list">
                                        {DOCS.map((doc) => (
                                            <div
                                                key={doc.id}
                                                className="docs-summary-item"
                                                onClick={() => this.openDoc(doc.id)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') this.openDoc(doc.id);
                                                }}
                                            >
                                                <div className="docs-summary-meta">
                                                    <span className="docs-summary-category">
                                                        {doc.category}
                                                    </span>
                                                    <h6 className="docs-summary-title">{doc.title}</h6>
                                                    <p className="docs-summary-text">{doc.summary}</p>
                                                </div>
                                                <span className="docs-summary-action">View</span>
                                            </div>
                                        ))}
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default DocsSummary;
